import type { CourseDetail } from "@/lib/types/course/detail"
import { Formatter } from "@/lib/helpers/formatter"
import { InfoItem } from "./InfoItem"

interface CourseDetailCardProps {
	data: CourseDetail
}

export const CourseDetailCard = ({ data }: CourseDetailCardProps) => (
	<div className="w-full max-w-md overflow-hidden">
		<div className="space-y-4 p-6">
			<h3 className="font-bold text-2xl text-gray-800">{data.name}</h3>

			<div className="space-y-2">
				<InfoItem label="Mã khóa học" value={data.code} />
				<InfoItem label="Hình thức" value={data.learning_mode} />
				<InfoItem label="Giảng viên" value={data.lecturer_name} />

				<div className="flex items-baseline">
					<span className="font-semibold text-gray-700">Học phí:</span>
					<span className="ml-2 font-bold text-lg text-red-600">
						{Formatter.formatMoney(data.price_discount)}
					</span>
					{data.price_discount !== data.price && (
						<span className="ml-2 text-gray-500 text-sm line-through">
							{Formatter.formatMoney(data.price)}
						</span>
					)}
				</div>

				<InfoItem label="Thời lượng" value={`${data.hour} giờ`} />
			</div>

			<div>
				<h4 className="mb-1 font-semibold text-gray-700">Mô tả:</h4>
				<p className="line-clamp-3 text-gray-600">{data.course_objective}</p>
			</div>
		</div>
	</div>
) 